import AbstractComponent from './abstract-component.js';

const getCheckboxMarkup = (values) => { // повтор, вынести
  return Object.values(values).map((value) => {
    return (
      `<label class="filter__checkbox">
        <input class="filter__checkboxInput" type="checkbox" data-id="${value.value}" data-title="${value.title}" ${value.isCheck ? `checked` : ``}>
        <span class="filter__checkboxLabel">${value.title}</span>
        ${value.count
        ? `<span class="filter__checkboxCount">${value.count}</span>`
        : ``}
      </label>`
    );
  }).join(`\n`);
};


const createTemplate = (title, minValue, maxValue, startValue, finishValue, step, values) => {
  const checkboxMarkup = getCheckboxMarkup(values);

  return (
    `<fieldset class="filter__item">
      <legend class="filter__itemTitle">${title}</legend>
      <div class="filter__wrap">
        <div class="filter__inputWrap">
          <input class="filter__input filter__input--start" type="number" value="${startValue / 10}" step="${step}">
          <span class="">–</span>
          <input class="filter__input filter__input--finish" type="number" value="${finishValue / 10}" step="${step}">
        </div>
        <div class="filter__rangeWrap">
          <div class="filter__rangeTrackWrap">
            <span class="filter__rangeTrack"></span>
          </div>
          <input class="filter__range filter__range--start" type="range" value="${startValue}" min="${minValue}" max="${maxValue}" step="${step}">
          <input class="filter__range filter__range--finish" type="range" value="${finishValue}" min="${minValue}" max="${maxValue}" step="${step}">
        </div>
        ${checkboxMarkup}

      </div>
    </fieldset>`
  );
};


export default class FilterRangeComponent extends AbstractComponent {
  constructor({title, alias, minValue, maxValue, startValue, finishValue, step, checkboxValues = {}}) {
    super();

    this._title = title;
    this._alias = alias;
    this._minValue = minValue;
    this._maxValue = maxValue;
    this._startValue = startValue;
    this._finishValue = finishValue;
    this._step = step;
    this._checkboxValues = checkboxValues;

    this._startInputElement = this.getElement().querySelector(`.filter__input--start`);
    this._finishInputElement = this.getElement().querySelector(`.filter__input--finish`);
    this._startRangeElement = this.getElement().querySelector(`.filter__range--start`);
    this._finishRangeElement = this.getElement().querySelector(`.filter__range--finish`);
    this._rangeTrackElement = this.getElement().querySelector(`.filter__rangeTrack`);
    this._checkboxElements = this.getElement().querySelectorAll(`.filter__checkboxInput`);


    this._onChangeHandler = null;

    this._fillColor();
  }

  getTemplate() {
    return createTemplate(this._title, this._minValue, this._maxValue, this._startValue, this._finishValue, this._step, this._checkboxValues);
  }

  onRangeChangeHandler(handler) {
    this._onChangeHandler = handler;

    this._onStartInputChangeHandler();
    this._onFinishInputChangeHandler();
    this._onStartRangeChangeHandler();
    this._onFinishRangeChangeHandler();
    this._onStartRangeInputHandler();
    this._onFinishRangeInputHandler();

    this._onCheckboxChangeHandler();
  }

  _onStartInputChangeHandler() {
    this._startInputElement.addEventListener(`change`, () => {
      let value = +this._startInputElement.value * 10;

      if (value < this._minValue) {
        value = this._minValue;
      }

      if (value > this._maxValue) {
        value = this._maxValue;
      }

      if (value > this._finishValue) {
        value = this._finishValue;
      }

      this._startInputElement.value = value / 10;

      this._startRangeElement.value = this._startValue = value;
      this._fillColor();

      this._onDataChange();
    });
  }

  _onFinishInputChangeHandler() {
    this._finishInputElement.addEventListener(`change`, () => {
      let value = +this._finishInputElement.value * 10;

      if (value < this._minValue) {
        value = this._minValue;
      }

      if (value > this._maxValue) {
        value = this._maxValue;
      }

      if (value < this._startValue) {
        value = this._startValue;
      }

      this._finishInputElement.value = value / 10;

      this._finishRangeElement.value = this._finishValue = value;
      this._fillColor();

      this._onDataChange();
    });
  }

  _onStartRangeInputHandler() {
    this._startRangeElement.addEventListener(`input`, () => {
      let value = Math.round(+this._startRangeElement.value);

      if (value > this._finishValue) {
        value = this._finishValue;
      }

      this._startRangeElement.value = this._startValue = value;

      this._startInputElement.value = value / 10;

      this._fillColor();
    });
  }

  _onStartRangeChangeHandler() {
    this._startRangeElement.addEventListener(`change`, () => {
      this._onDataChange();
    });
  }

  _onFinishRangeInputHandler() {
    this._finishRangeElement.addEventListener(`input`, () => {
      let value = Math.round(+this._finishRangeElement.value);

      if (value < this._startValue) {
        value = this._startValue;
      }

      this._finishRangeElement.value = this._finishValue = value;

      this._finishInputElement.value = value / 10;
      this._fillColor();
    });
  }

  _onFinishRangeChangeHandler() {
    this._finishRangeElement.addEventListener(`change`, () => {
      this._onDataChange();
    });
  }

  _onCheckboxChangeHandler() {
    Array.from(this._checkboxElements).forEach((checkbox) => {
      checkbox.addEventListener(`change`, () => {
        this._onDataChange(checkbox);
      });
    });
  }

  _onDataChange(activeElement = this._startInputElement) {
    const min = this._startValue === this._minValue ? `` : this._startValue / 10;
    const max = this._finishValue === this._maxValue ? `` : this._finishValue / 10;

    const values = Array.from(this._checkboxElements)
      .filter((ch) => ch.checked)
      .map((ch) => {
        return {
          id: ch.dataset.id,
          title: ch.dataset.title,
        };
      });

    this._onChangeHandler({
      alias: this._alias,
      title: this._title,
      min,
      max,
      values,
    }, activeElement);
  }

  _fillColor() {
    const range = this._maxValue - this._minValue;

    const percent1 = ((this._startValue - this._minValue) / range) * 100;
    const percent2 = ((this._finishValue - this._minValue) / range) * 100;

    this._rangeTrackElement.style.left = `${percent1}%`;
    this._rangeTrackElement.style.right = `${100 - percent2}%`;
  }
}
